export default __webpack_public_path__ + "static/media/day5.78645ea4.png";